<template>
    <section
        id="setup"
        aria-labelledby="setup-heading"
        class="mx-auto max-w-7xl px-4 py-24 sm:px-6 lg:px-8"
    >
        <div class="max-w-2xl">
            <h2
                id="setup-heading"
                class="text-3xl font-bold tracking-tight"
            >
                Launch your online presence in minutes
            </h2>
            <p class="mt-3 text-slate-600">
                A simple setup flow for solo experts who want one professional
                page to share fast.
            </p>
        </div>

        <ol class="mt-10 grid gap-6 lg:grid-cols-3">
            <li
                v-for="step in steps"
                :key="step.stepNumber"
                class="contents"
            >
                <article
                    class="rounded-xl border border-slate-200 bg-white p-6 shadow-xs shadow-slate-200/70"
                    :aria-labelledby="`setup-step-${step.stepNumber}-heading`"
                >
                    <p class="text-sm font-bold text-primary-shade">
                        Step {{ step.stepNumber }}
                    </p>
                    <h3
                        :id="`setup-step-${step.stepNumber}-heading`"
                        class="mt-2 text-lg font-bold"
                    >
                        {{ step.title }}
                    </h3>
                    <p class="mt-2 text-slate-600">{{ step.description }}</p>
                </article>
            </li>
        </ol>
    </section>
</template>

<script setup lang="ts">
    interface Step {
        stepNumber: number
        title: string
        description: string
    }

    const steps: Step[] = [
        {
            stepNumber: 1,
            title: 'Connect your calendar',
            description:
                'Sync Google Calendar or Outlook Calendar so your availability stays accurate and double bookings stay blocked.',
        },
        {
            stepNumber: 2,
            title: 'Create your offers',
            description:
                'Add discovery calls, strategy sessions, or paid offers with durations, pricing, and intake questions.',
        },
        {
            stepNumber: 3,
            title: 'Share one clean page',
            description:
                'Send your page in email, DMs, social profiles, or from your website contact flow.',
        },
    ]
</script>
